import { createSelectorPage } from 'pages/common/selector'
import { urls } from 'urls'

const metadata = {
  title: 'menu.orders',
  baseUrl: urls.orders.base
}
const OrderSelectorPage = createSelectorPage({ metadata })

export {
  OrderSelectorPage
}